import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {Router} from "@angular/router";
import {Session} from "../../services/session.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {

  password: string;
  sentinel: string = "4321@tideeS"; //Seedit@1234
  message: string = "";

  constructor(private router: Router) { }

  ngOnInit() {
  }

  login(){
    this.message = "";
    let success: boolean = true;
    let length: number = this.sentinel.length - 1;
    for(let i = length; i >= 0; i--){
      success = success && this.sentinel.charAt(i) == this.password.charAt(length - i);
    }

    Session.loggedIn = success;
    if (success) {
      this.router.navigate(["/home"]);
    }
    else{
      this.message = "Password not correct";
    }
    Session.loggedInObserver.next(success);
  }
}



// WEBPACK FOOTER //
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/pages/login/login.component.ts